const renderStepsModal = () => {
  const pageBody = document.querySelector('body');
  const stepsModal = document.querySelector('.steps__modal');

  const onCardClick = (evt) => {
    if (evt.target.closest('[data-modal-id="steps-modal"]')) {
      const targetCard = evt.target.closest('.steps__item');
      const modalContent = targetCard.querySelector('.steps__item-hidden').cloneNode(true);
      stepsModal.innerHTML = modalContent.innerHTML;
    }
  };

  stepsModal && pageBody.addEventListener('click', onCardClick);
};

export default renderStepsModal;
